// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"b4850d59","126":"341b9bb1","375":"49e2bf18","450":"1e2d5de7","674":"c76584c1","702":"9e37863b","818":"3f13aff9"}[chunkId] + ".chunk.js";
};